import { z } from 'zod';

/**
 * Form de Vale.
 *
 * Regras (card [nP3xbHZ6] T-23 Fase 1):
 * - `dataSolicitacao` ISO `YYYY-MM-DD`.
 * - `valor` numérico > 0.
 * - `nroParcelas` inteiro > 0.
 * - `vencimento1aParcela` ISO `YYYY-MM-DD`.
 *
 * Update server-side bloqueado se `status != ABE` — a UI desabilita o botão
 * Edit em vales `PAG`/`CAN`, então o form só renderiza para vales editáveis.
 */
export const employeeValeInputSchema = z.object({
  dataSolicitacao: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida (use AAAA-MM-DD)'),
  valor: z
    .number({ invalid_type_error: 'Valor obrigatório' })
    .positive('Valor deve ser maior que zero'),
  nroParcelas: z
    .number({ invalid_type_error: 'Nº de parcelas obrigatório' })
    .int('Use número inteiro')
    .positive('Deve ser maior que zero'),
  vencimento1aParcela: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida (use AAAA-MM-DD)'),
});

export type EmployeeValeFormValues = z.infer<typeof employeeValeInputSchema>;

/**
 * Form de baixa de parcela do vale (Fase 2 Pacote A, card [h7TE7xcf]).
 *
 * Regras server-side espelhadas client-side:
 * - `dataPagamento` ISO `YYYY-MM-DD`.
 * - `valorPago` > 0.
 *
 * Vínculo opcional com NF Colaborador (`nfColaboradorCodigo` + `nfNotaFiscalCodigo`)
 * fica de fora do MVP — proc aceita o par, mas UI não vai expor por enquanto
 * (sem demanda; seleção de NF Colab cabível em iteração futura).
 */
export const employeeValeParcelaBaixarSchema = z.object({
  dataPagamento: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida (use AAAA-MM-DD)'),
  valorPago: z
    .number({ invalid_type_error: 'Valor pago obrigatório' })
    .positive('Valor pago deve ser maior que zero'),
});

export type EmployeeValeParcelaBaixarFormValues = z.infer<typeof employeeValeParcelaBaixarSchema>;
